module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: (_vm.scroll),
      expression: "scroll"
    }],
    staticClass: "block-scroll-button"
  }, [_vm._t("default", [_c('div', {
    staticClass: "block-scroll-button",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label)
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fca2463","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-scroll-button/block-scroll-button.pug
// module id = 576
// module chunks = 1